module.exports = __webpack_public_path__ + "static/media/illuminate.cb9b7d1d.png";